import { useState } from 'react'
import StatusSnackbar, { Status } from '../../../common/StatusSnackbar'
import ChatImageInsertion from './ChatImageInsertion'
import ImageLibrarySubmission from './ImageLibrarySubmission'
import { Container, Divider } from './Shared'

interface ImageFeaturesProps {
    onInsertImage: (shortcut: string) => void
}

const ImageUpload = (props: ImageFeaturesProps) => {
    const { onInsertImage } = props
    const [status, setStatus] = useState<Status>(null)

    const handleCloseStatus = () => {
        setStatus(null)
    }

    return (
        <Container>
            <ChatImageInsertion
                onInsertImage={onInsertImage}
                setStatus={setStatus}
            />
            <Divider />
            <ImageLibrarySubmission setStatus={setStatus} />
            <StatusSnackbar status={status} onClose={handleCloseStatus} />
        </Container>
    )
}

export default ImageUpload
